function updateCheckboxAvailability(termRead, checkbox) {
  checkbox.disabled = !termRead;
}

function setupScrollEnabling(modal, onFullyRead) {
  const body = modal.querySelector('.terms-modal-body');
  const button = modal.querySelector('.js-terms-confirm-btn');

  function maybeEnableButton() {
    if (!body) return;

    const scrollBottom = body.scrollTop + body.clientHeight;
    const scrollHeight = body.scrollHeight;

    if (scrollBottom >= scrollHeight - 5) {
      button.disabled = false;
    }
  }

  // Bootstrap 4 fires modal events through jQuery, not native DOM
  $(modal).on('shown.bs.modal', function () {
    button.disabled = true;
    body.removeEventListener('scroll', maybeEnableButton);
    body.addEventListener('scroll', maybeEnableButton);
    maybeEnableButton();
  });

  $(modal).on('hidden.bs.modal', function () {
    body.removeEventListener('scroll', maybeEnableButton);
  });

  button.addEventListener('click', function () {
    if (button.disabled) return;
    if (typeof onFullyRead === 'function') {
      onFullyRead();
    }
    // Bootstrap 4 modal API requires jQuery
    $(modal).modal('hide');
  });
}

document.addEventListener('DOMContentLoaded', function () {
  setupTermsModals();
});

function setupTermsModals() {
  if (!document.querySelector('.registration')) return;

  let impactTermsRead = false;
  let procurationRead = false;
  let mangopayRead = false;

  const cguCheckbox = document.querySelector('.js-terms-cgu-checkbox');
  const mangopayCheckbox = document.querySelector('.js-terms-mangopay-checkbox');
  const procurationCheckbox = document.querySelector('.js-terms-procuration-checkbox');

  const impactModal = document.getElementById('impactTermsModal');
  const procurationModal = document.getElementById('procurationModal');

  updateCheckboxAvailability(impactTermsRead, cguCheckbox);
  updateCheckboxAvailability(mangopayRead, mangopayCheckbox);
  updateCheckboxAvailability(procurationRead, procurationCheckbox);

  document.querySelector('.js-impact-cgu-link').addEventListener('click', function (event) {
    event.preventDefault();
    // Bootstrap 4 modal API requires jQuery
    $(impactModal).modal('show');
  });

  document.querySelector('.js-procuration-link').addEventListener('click', function (event) {
    event.preventDefault();
    // Bootstrap 4 modal API requires jQuery
    $(procurationModal).modal('show');
  });

  document.querySelector('.js-mangopay-cgu-link').addEventListener('click', function () {
    mangopayRead = true;
    updateCheckboxAvailability(mangopayRead, mangopayCheckbox);
  });

  setupScrollEnabling(impactModal, function () {
    impactTermsRead = true;
    updateCheckboxAvailability(impactTermsRead, cguCheckbox);
  });

  setupScrollEnabling(procurationModal, function () {
    procurationRead = true;
    updateCheckboxAvailability(procurationRead, procurationCheckbox);
  });
}
